/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../../../action';
import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const dispatch = useDispatch();

    const cBFrontWallCloseState = useSelector((state) => state.reducer.frontWallCloseState)

    const [rightWallCloseSize, setRightWallCloseSize] = useState(0);
    const [leftWallCloseSize, setLeftWallCloseSize] = useState(0);

    const wallThickness = 0.005;
    const Temp_F_p_w = params.leanF_p_w - 0.3;

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined])

    const frontOffset = useMemo(() => {
        if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front)) {
            return -0.3;
        } else if (params.frontLeanStoragePosition === 0) {
            return 0.3;
        } else {
            return 0;
        }
    }, [params.leanF_p_d, legDistance, params.frontLeanStoragePosition, params.add_storage_front]);

    const backOffset = useMemo(() => {
        if (params.frontLeanStoragePosition === 0) {
            return 0.3;
        } else {
            return 0;
        }
    }, [params.frontLeanStoragePosition]);

    const sideWallOffset = 0.15;
    
    const frontLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(params.p_b_c_b_f_l !== 'Close'){
            if(params.p_b_c_b_f_l === 'Open'){
                model.moveTo(Temp_F_p_w / 2 + 0, 0);
                model.lineTo(Temp_F_p_w / 2 + 0, params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
                model.lineTo(Temp_F_p_w / 2 + 0.23, params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
                model.lineTo(Temp_F_p_w / 2 + 0.23, 0);
                model.closePath();
            } else {
                model.moveTo(Temp_F_p_w / 2 + 0, leftWallCloseSize + 0.1);
                model.lineTo(Temp_F_p_w / 2 + 0, 0);
                model.lineTo(Temp_F_p_w / 2 + 0.23, 0);
                model.lineTo(Temp_F_p_w / 2 + 0.23, leftWallCloseSize + 0.1);
                model.closePath();
            }
        }

        return model;
    }, [params.leanF_p_h, Temp_F_p_w, leftWallCloseSize, params.p_b_c_b_f_l, params.b_l_t_r_pF])
    
    const frontRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(params.p_b_c_b_f_r !== 'Close'){
            if(params.p_b_c_b_f_r === 'Open'){
                model.moveTo(-(Temp_F_p_w / 2 + 0.235), 0);
                model.lineTo(-(Temp_F_p_w / 2 + 0.235), params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
                model.lineTo(-(Temp_F_p_w / 2 + 0), params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
                model.lineTo(-(Temp_F_p_w / 2 + 0), 0);
                model.closePath();
            } else {
                model.moveTo(-(Temp_F_p_w / 2 + 0.235), rightWallCloseSize + 0.1);
                model.lineTo(-(Temp_F_p_w / 2 + 0.235), 0);
                model.lineTo(-(Temp_F_p_w / 2 + 0), 0);
                model.lineTo(-(Temp_F_p_w / 2 + 0), rightWallCloseSize + 0.1);
                model.closePath();
            }
        }

        return model;
    }, [params.leanF_p_h, Temp_F_p_w, rightWallCloseSize, params.p_b_c_b_f_r, params.b_l_t_r_pF])

    const leftTrimObj = useMemo(() => {
        const trimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontLeftVrTrimModel, extrudeSettings(0.16)), new THREE.MeshStandardMaterial({color: 'red'}));
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const frontTrimModel_Temp = trimModel.clone();
        frontTrimModel_Temp.position.set(0, 0, -0.08 - frontOffset - sideWallOffset);
        frontTrimModel_Temp.updateMatrixWorld();

        const backTrimModel_Temp = trimModel.clone();
        backTrimModel_Temp.position.set(0, 0, 0.03 + parseInt(params.add_storage_front) + sideWallOffset);
        backTrimModel_Temp.updateMatrixWorld();

        const doorDelModel_Temp = meshDoorDelModelLeft.clone();
        doorDelModel_Temp.position.set(params.leanF_p_w / 2 + 0.5, 0, params.frontLeanStoragePosition + parseInt(params.add_storage_front) + params.p_d / 2);
        doorDelModel_Temp.rotation.y = -Math.PI / 2;
        doorDelModel_Temp.updateMatrixWorld();

        const frontTrimModel_CSG = CSG.fromMesh(frontTrimModel_Temp);
        const backTrimModel_CSG = CSG.fromMesh(backTrimModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(doorDelModel_Temp);

        const frontTrimModel_CSG_Temp = frontTrimModel_CSG.subtract(meshDoorDelModel_CSG);
        const backTrimModel_CSG_Temp = backTrimModel_CSG.subtract(meshDoorDelModel_CSG);

        const frontTrimModel = CSG.toMesh(frontTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;
        const backTrimModel = CSG.toMesh(backTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;

        return {frontTrimModel, backTrimModel}
    }, [frontLeftVrTrimModel, const_var.newDoorsArray, params.leanF_p_w, params.frontLeanStoragePosition, params.add_storage_front])

    const rightTrimObj = useMemo(() => {
        const trimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontRightVrTrimModel, extrudeSettings(0.16)), new THREE.MeshStandardMaterial({color: 'red'}));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const frontTrimModel_Temp = trimModel.clone();
        frontTrimModel_Temp.position.set(0, 0, -0.08 - frontOffset - sideWallOffset);
        frontTrimModel_Temp.updateMatrixWorld();

        const backTrimModel_Temp = trimModel.clone();
        backTrimModel_Temp.position.set(0, 0, 0.03 + parseInt(params.add_storage_front) + sideWallOffset);
        backTrimModel_Temp.updateMatrixWorld();

        const doorDelModel_Temp = meshDoorDelModelRight.clone();
        doorDelModel_Temp.position.set( -params.leanF_p_w / 2 + 0.5, 0, params.frontLeanStoragePosition + parseInt(params.add_storage_front) + params.p_d / 2);
        doorDelModel_Temp.rotation.y = -Math.PI / 2;
        doorDelModel_Temp.updateMatrixWorld();

        const frontTrimModel_CSG = CSG.fromMesh(frontTrimModel_Temp);
        const backTrimModel_CSG = CSG.fromMesh(backTrimModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(doorDelModel_Temp);

        const frontTrimModel_CSG_Temp = frontTrimModel_CSG.subtract(meshDoorDelModel_CSG);
        const backTrimModel_CSG_Temp = backTrimModel_CSG.subtract(meshDoorDelModel_CSG);

        const frontTrimModel = CSG.toMesh(frontTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;
        const backTrimModel = CSG.toMesh(backTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;

        return {frontTrimModel, backTrimModel}
    }, [frontRightVrTrimModel, const_var.newDoorsArray, params.leanF_p_w, params.frontLeanStoragePosition, params.add_storage_front])
    
    const frontWallWainscotTrimObj = useMemo(() => {
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_F_p_w + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanStorageFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(-(Temp_F_p_w / 2 + 0.02), 3 , 0.01 - frontOffset - sideWallOffset)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanF_p_pos, 0, 0);
        meshDelModel_Temp.rotation.y = Math.PI;
        meshDelModel_Temp.updateMatrixWorld();

        let meshDoorDelModelLeft_Temp = meshDoorDelModelLeft.clone();
        meshDoorDelModelLeft_Temp.position.set(params.leanF_p_w / 2 + 0.8, 0, params.frontLeanStoragePosition + parseInt(params.add_storage_front) + params.p_d / 2);
        meshDoorDelModelLeft_Temp.rotation.y = -Math.PI / 2;
        meshDoorDelModelLeft_Temp.updateMatrixWorld();
    
        let meshDoorDelModelRight_Temp = meshDoorDelModelRight.clone();
        meshDoorDelModelRight_Temp.position.set( -params.leanF_p_w / 2 + 0.25, 0, params.frontLeanStoragePosition + parseInt(params.add_storage_front) + params.p_d / 2);
        meshDoorDelModelRight_Temp.rotation.y = -Math.PI / 2;
        meshDoorDelModelRight_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshDoorDelModelLeft_CSG = CSG.fromMesh(meshDoorDelModelLeft_Temp);
        const meshDoorDelModelRight_CSG = CSG.fromMesh(meshDoorDelModelRight_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const WainscotTrimModel_CSG_temp1 = WainscotTrimModel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const WainscotTrimModel_CSG_temp2 = WainscotTrimModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG_temp2, new THREE.Matrix4());

        return CSGWainscotTrimModel.geometry;
    }, [Temp_F_p_w, params.leanF_p_pos, params.leanF_p_h, const_var.newDoorsArray, frontOffset, params.frontLeanStoragePosition, parseInt(params.add_storage_front), params.p_d])

    const backWallWainscotTrimObj = useMemo(() => {
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_F_p_w + 0.3)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanStorageBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((Temp_F_p_w / 2 + 0.15), 3 , 0.03 + parseInt(params.add_storage_front) + 0.07 + sideWallOffset)
        meshWainscotTrimModel_Temp.rotation.y = -Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotation.y = Math.PI;
        meshDelModel_Temp.position.set(params.leanF_p_pos, 0, parseInt(params.add_storage_front) + 0.5);
        meshDelModel_Temp.updateMatrixWorld();

        let meshDoorDelModelLeft_Temp = meshDoorDelModelLeft.clone();
        meshDoorDelModelLeft_Temp.position.set(params.leanF_p_w / 2 + 0.8, 0, params.frontLeanStoragePosition + parseInt(params.add_storage_front) + params.p_d / 2);
        meshDoorDelModelLeft_Temp.rotation.y = -Math.PI / 2;
        meshDoorDelModelLeft_Temp.updateMatrixWorld();
    
        let meshDoorDelModelRight_Temp = meshDoorDelModelRight.clone();
        meshDoorDelModelRight_Temp.position.set( -params.leanF_p_w / 2 + 0.25, 0, params.frontLeanStoragePosition + parseInt(params.add_storage_front) + params.p_d / 2);
        meshDoorDelModelRight_Temp.rotation.y = -Math.PI / 2;
        meshDoorDelModelRight_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshDoorDelModelLeft_CSG = CSG.fromMesh(meshDoorDelModelLeft_Temp);
        const meshDoorDelModelRight_CSG = CSG.fromMesh(meshDoorDelModelRight_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const WainscotTrimModel_CSG_temp1 = WainscotTrimModel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const WainscotTrimModel_CSG_temp2 = WainscotTrimModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG_temp2, new THREE.Matrix4());

        return CSGWainscotTrimModel.geometry;
    }, [Temp_F_p_w, params.leanF_p_pos, params.leanF_p_h, const_var.newDoorsArray, params.add_storage_front, params.frontLeanStoragePosition])

    const rightWallWainscotTrimObj = useMemo(() => {
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_front) + frontOffset + sideWallOffset * 2 - backOffset)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(-(Temp_F_p_w / 2 + 0.155), 3 , parseInt(params.add_storage_front) + sideWallOffset - backOffset)
        meshWainscotModel_Temp.rotation.y = Math.PI
        meshWainscotModel_Temp.updateMatrixWorld();
    
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotation.y = -Math.PI / 2
        meshDelModel_Temp.position.set(-Temp_F_p_w / 2 + 0.5, 0, params.p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + 0.055);
        meshDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);

        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG,new THREE.Matrix4())

        return CSGWainscotModel.geometry;
    }, [params.leanF_p_d, Temp_F_p_w, params.p_w, rightWallCloseSize, params.frontLeanStoragePosition, const_var.newDoorsArray, params.leanF_p_pos, params.add_storage_front, frontOffset])

    const leftWallWainscotTrimObj = useMemo(() => {
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_front) + frontOffset + sideWallOffset * 2 - backOffset)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set((Temp_F_p_w / 2 + 0.155), 3 , -frontOffset - sideWallOffset)
        meshWainscotModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI / -2);
        meshDelModel_Temp.position.set((Temp_F_p_w / 2) + 0.5, 0, params.p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition);
        meshDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
    
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG,new THREE.Matrix4())

        return CSGWainscotModel.geometry
    }, [params.leanF_p_d, Temp_F_p_w, params.p_w, const_var.newDoorsArray, params.frontLeanStoragePosition, leftWallCloseSize, params.leanF_p_pos, params.add_storage_front, frontOffset])
    
    // --- right wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_r === 'Open' || typeof(params.p_b_c_b_f_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_r === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_r;
        }

        setRightWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLRightWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_f_r, params.leanF_p_h, params.p_r_s])

    // --- left wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_l === 'Open' || typeof(params.p_b_c_b_f_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_l === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_l;
        }

        setLeftWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLLeftWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_f_l, params.leanF_p_h, params.p_r_s])

    return (
        <>
            <group position={[0, 0, (params.p_d / 2 + parseInt(params.add_storage_front) + 0.05 + wallThickness)]} rotation={[0, Math.PI, 0]}>
                {params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) && <>
                    {params.p_b_c_b_f_l !== 'Close' && <mesh name="front-wall-left-trim" geometry={leftTrimObj.frontTrimModel}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>}
                    {params.p_b_c_b_f_r !== 'Close' && <mesh name="front-wall-right-trim" geometry={rightTrimObj.frontTrimModel}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>}
                    {params.p_w_c_n === true &&
                        <mesh name="G_F_L_S_F_W_wainscotTrim" geometry={frontWallWainscotTrimObj} >
                            <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                        </mesh>
                    }
                </>}
                {params.frontLeanStoragePosition !== 0 && <>
                    {params.p_b_c_b_f_l !== 'Close' && <mesh name="back-wall-left-trim" geometry={leftTrimObj.backTrimModel}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>}
                    {params.p_b_c_b_f_r !== 'Close' && <mesh name="back-wall-right-trim" geometry={rightTrimObj.backTrimModel}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>}
                    {params.p_w_c_n === true && (cBFrontWallCloseState > 3 || params.frontLeanStoragePosition !== 0) && 
                        <mesh name="G_F_L_S_B_W_wainscotTrim" geometry={backWallWainscotTrimObj}>
                            <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                        </mesh>
                    }
                </>}
                {params.p_w_c_n === true &&
                    <mesh name="G_F_L_S_R_W_wainscotTrim" geometry={rightWallWainscotTrimObj} >
                        <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true &&
                    <mesh name="G_F_L_S_L_W_wainscotTrim" geometry={leftWallWainscotTrimObj} >
                        <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                    </mesh>
                }
            </group>
        </>
    )
}

export default TrimModel